module.exports = __webpack_public_path__ + "assets/img/pause.f08c6c0a.svg";